import { useSelector } from 'react-redux';
import useLocalize from './useLocalize';
import { findKeyRecursivelyInObject } from '../utils/functionUtils';

const useAnalytics = () => {
	const sendEventsArr = useSelector(
		(state) => state?.analytics?.sendEventsArr,
	);
	const storeID = useSelector((state) => state?.storeData?.id);
	const scenes = useSelector((state) => state?.scenes);
	const activeSceneID = useSelector((state) => state?.sceneLoad?.activeScene);
	// const modalData = useSelector(
	// 	(state) =>
	// 		Object.values(state?.modalData).filter(
	// 			(data) => data?.visible === true,
	// 		)[0],
	// );
	const { activeLocale } = useLocalize();

	const collect = (trackingData) => {
		const toCollect = trackingData;

		if (activeLocale) {
			toCollect.locale = activeLocale;
		}
		const productSku = findKeyRecursivelyInObject(trackingData, 'item_id');
		if (productSku) {
			toCollect.product_sku = toCollect.product_sku || productSku;
		}
		toCollect.store_id = storeID;
		toCollect.scene_id = activeSceneID;
		toCollect.scene_name = scenes[activeSceneID]?.name;
		toCollect.hotspot_id = trackingData?.hotspot_id;
		toCollect.hotspot_name = trackingData?.hotspot_name;
		toCollect.hotspot_type = trackingData?.hotspot_type;

		sendEventsArr.forEach((sendEvent) => {
			sendEvent(toCollect);
		});
	};

	window.collect = collect;

	return {
		collect,
	};
};

export default useAnalytics;
